var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ListPage,{attrs:{"isLoading":_setup.state.isLoading,"title":_vm.title,"subtitle":_vm.subtitle,"filters":_setup.getFilters(),"table":_setup.getTable(),"paginator":_setup.getPaginator(),"actions":_setup.getActions()}})
}
var staticRenderFns = []

export { render, staticRenderFns }